<template>
  <div class="container">
    <b-row>
      <div class="col-6">
        <div class="ld-card-header">
          <img src="@/assets/images/logos/logoMarioViajes.png" alt="" height="50px">
        </div>
      </div>
      <div class="col-6 d-flex align-items-center justify-content-end">
        <div>
          <button class="btn btn-outline-primary btn-xs " @click="$emit('print')" v-b-tooltip.hover :title="$gettext('print')">
            <b-icon icon="file-earmark-text" />
          </button>
          <button class="btn btn-outline-danger btn-xs mx-2" @click="$emit('download')" v-b-tooltip.hover :title="$gettext('PDF')">
            <b-icon icon="download" />
          </button>
          <button class="btn btn-outline-info btn-xs " @click="$emit('closeModal')" v-b-tooltip.hover :title="$gettext('close')">
            <b-icon icon="x" />
          </button>
        </div>
      </div>
      <b-col><hr></b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'modalHeader'
}
</script>
